/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateOrderpickerDto } from '../../models/create-orderpicker-dto';
import { OrderpickerCompany } from '../../models/orderpicker-company';

export interface CreateOneBaseMgmtOrderpickerControllerOrderpickerCompany$Params {
      body: CreateOrderpickerDto
}

export function createOneBaseMgmtOrderpickerControllerOrderpickerCompany(http: HttpClient, rootUrl: string, params: CreateOneBaseMgmtOrderpickerControllerOrderpickerCompany$Params, context?: HttpContext): Observable<StrictHttpResponse<OrderpickerCompany>> {
  const rb = new RequestBuilder(rootUrl, createOneBaseMgmtOrderpickerControllerOrderpickerCompany.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<OrderpickerCompany>;
    })
  );
}

createOneBaseMgmtOrderpickerControllerOrderpickerCompany.PATH = '/api/mgmt/orderpickers';
